import {gql, Apollo} from 'apollo-angular';
import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {first, map} from "rxjs/operators";

// We use the gql tag to parse our query string into a query document
const produceCommonDataGql = () => {
    return gql`
      query CommonData {
          ProgramGroup {
            programGroupId
            description
            name
          }
		  Program {
			programId
			description
			name
			programGroup {
			  programGroupId
			  description
			  name
		    }
		  }
          PrefixType (name: ["MR", "MRS", "MS", "MISS", "DR"]) {
            name,
            cmgmtPrefixTypeId,
            description
          }
          EmailType (name: ["HOME", "WORK"] ) {
            name,
            cmgmtEmailTypeId,
            description
          }
          PhoneType (name: ["HOME", "WORK", "CELLULAR"] ) {
            name,
            cmgmtPhoneTypeId,
            description
          }
          AddressType (name: ["HOME", "WORK"] ) {
            name,
            addressTypeId,
            description
          }
          Country (billableCountry: true) {
            country
            description
            billableCountry
            displayOrder(orderBy: ASC)
            extCountryId
            countrycode
          }
          StateProvince: Country(countrycode: ["US", "CA"]) {
			stateProvinces {
			  description
			  extStateProvinceId
			  state
			}
          }
          EmergencyContactType {
            description
            name
            emergencyContactTypeId
          }
          ConstituentRelationshipType {
            gender
            description
            cmgmtRelationshipCategoryTypeId
            constituentRelationshipTypeId
            name
          }
      }
    `;
}

export const CommonDataResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const apollo = inject(Apollo);

    return apollo.query<any>({
        query: produceCommonDataGql()
    }).pipe(map(res => {
        return res.data;
    }),first());
}
